import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';

import { ButtonContainer, StyledSingleButton, StyledSubtitle } from '../../styles';

export const EligibilityConfirmation = ({ handleNextClick }) => {
  useSegmentTrack(UNIFIED.viewOnboardingEligibilityConfirmation);

  return (
    <Step
      title="Great news! We deliver to you"
      text={
        <StyledSubtitle maxWidth={55}>
          Have a prescription at another pharmacy? Answer a few simple questions to move your prescription to Capsule
          (it takes 15 seconds).
        </StyledSubtitle>
      }
    >
      <ButtonContainer>
        <StyledSingleButton size="medium" onClick={handleNextClick}>
          Continue
        </StyledSingleButton>
      </ButtonContainer>
    </Step>
  );
};
